module.exports = __webpack_public_path__ + "img/mic_close2.ef047d19.svg";